<div class="login-container">
  <!-- Split Screen Layout -->
  <div class="login-split">
    <!-- Left Panel: Branding & Info -->
    <div class="branding-panel">
      <div class="branding-content">
        <!-- Logo Section -->
        <div class="logo-section">
          <div class="logo-icon">
            <mat-icon>business_center</mat-icon>
          </div>
          <h1 class="brand-name">Equidesk</h1>
          <p class="brand-subtitle">Admin Panel</p>
        </div>

        <!-- Feature Highlights -->
        <div class="features-section">
          <div class="feature-item">
            <mat-icon>check_circle</mat-icon>
            <div class="feature-text">
              <h3>Comprehensive Management</h3>
              <p>Manage tenants, modules, and system settings from one place</p>
            </div>
          </div>
          <div class="feature-item">
            <mat-icon>security</mat-icon>
            <div class="feature-text">
              <h3>Enterprise Security</h3>
              <p>Role-based access control and secure authentication</p>
            </div>
          </div>
          <div class="feature-item">
            <mat-icon>analytics</mat-icon>
            <div class="feature-text">
              <h3>Real-time Insights</h3>
              <p>Track system performance and user activity</p>
            </div>
          </div>
        </div>

        <!-- Footer Info -->
        <div class="branding-footer">
          <p>&copy; 2025 Equidesk. All rights reserved.</p>
        </div>
      </div>
    </div>

    <!-- Right Panel: Login Form -->
    <div class="form-panel">
      <div class="form-content">
        <!-- Form Header -->
        <div class="form-header">
          <h2>Welcome Back</h2>
          <p>Sign in to access the admin panel</p>
        </div>

        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <!-- Email Field -->
          <div class="form-group">
            <label class="form-label">
              Email Address
              <span class="required">*</span>
            </label>
            <mat-form-field appearance="outline" class="form-field">
              <input
                matInput
                type="email"
                formControlName="email"
                placeholder="Enter your email address"
              />
              <mat-icon matPrefix>email</mat-icon>
              <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
                Email is required
              </mat-error>
              <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
                Please enter a valid email
              </mat-error>
              <mat-error *ngIf="loginForm.get('email')?.hasError('serverError')">
                {{ loginForm.get('email')?.getError('serverError') }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Password Field -->
          <div class="form-group">
            <label class="form-label">
              Password
              <span class="required">*</span>
            </label>
            <mat-form-field appearance="outline" class="form-field">
              <input
                matInput
                [type]="hidePassword ? 'password' : 'text'"
                formControlName="password"
                placeholder="Enter your password"
              />
              <mat-icon matPrefix>lock</mat-icon>
              <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
                Password is required
              </mat-error>
              <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">
                Password must be at least 6 characters
              </mat-error>
              <mat-error *ngIf="loginForm.get('password')?.hasError('serverError')">
                {{ loginForm.get('password')?.getError('serverError') }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Submit Button -->
          <button
            mat-raised-button
            type="submit"
            class="btn-primary btn-lg btn-full-width"
            [disabled]="loginForm.invalid || isLoading"
          >
            @if (isLoading) {
              <mat-spinner diameter="24" class="button-spinner"></mat-spinner>
            } @else {
              <span>Sign In</span>
            }
          </button>
        </form>

      </div>
    </div>
  </div>
</div>
